import { Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import useLayoutTypeContext from '../hooks/useLayoutTypeContext';

const AryNoContentInfoBox = ({
  icon,
  text,
  height,
  minHeight,
  iconSize,
  textVariant,
  buttonProps = [],
  customWidth
}) => {
  const theme = useTheme();
  const layoutType = useLayoutTypeContext();
  const Icon = icon;
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Stack
      direction="column"
      spacing={layoutType === 'mobile' ? '12px' : '30px'}
      alignItems="center"
      justifyContent="center"
      sx={{
        width: customWidth || 'inherit',
        minHeight: minHeight || (layoutType === 'mobile' ? '100px' : '200px'),
        height
      }}
    >
      <Icon
        sx={{
          width: iconSize || (layoutType === 'mobile' ? '50px' : '70px'),
          height: iconSize || (layoutType === 'mobile' ? '50px' : '70px'),
          color: theme.text.tertiary.color
        }}
      />
      <Typography
        variant={textVariant}
        sx={{ color: theme.text.secondary.color }}
      >
        {text}
      </Typography>
      {buttonProps && buttonProps.length === 1 && (
        <Button
          size={layoutType === 'mobile' ? 'small' : 'medium'}
          variant="contained"
          onClick={() => {
            if (buttonProps[0].navigate) {
              navigate(buttonProps[0].navigate);
            }
            if (buttonProps[0].onClick) {
              buttonProps[0].onClick();
            }
          }}
        >
          {buttonProps[0].title}
        </Button>
      )}
      {buttonProps && buttonProps.length > 1 && (
        <>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            variant="contained"
            sx={{
              width: '147px'
            }}
          >
            {buttonProps[0].title}
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
            sx={{
              '& .MuiPaper-root': {
                minWidth: '147px'
              }
            }}
          >
            {buttonProps
              .slice(1)
              .map(
                (
                  {
                    title: titleProp,
                    navigate: navigateProp,
                    onClick: onClickProp
                  },
                  index
                ) => (
                  <MenuItem
                    key={index}
                    onClick={() => {
                      setAnchorEl(null);
                      if (navigateProp) {
                        navigate(navigateProp);
                      }
                      if (onClickProp) {
                        onClickProp();
                      }
                    }}
                  >
                    {titleProp}
                  </MenuItem>
                )
              )}
          </Menu>
        </>
      )}
    </Stack>
  );
};

export default AryNoContentInfoBox;
